<template>
  <div class="TupianLabel">

    <!-- 图片 -->
    <template v-if="tupianItem.type == 1 || !tupianItem.type">
      <!-- 图片包图标 -->
      <i v-if="tupianItem.package == 1" class="icon_badge pic-package-legal-copy"/>
      <!-- 图片标签 -->
      <template v-else>
        <!-- layer 内容层次: 1免费区, 2普通区, 3商用区, 4企业区 -->
        <i class=" label-item free" v-if="tupianItem.layer == 1">免费下载</i>
        <i class=" label-item person" v-if="tupianItem.layer == 2">会员专享</i>
        <i class=" label-item business" v-if="tupianItem.layer == 3">个人商用</i>
        <i class=" label-item company" v-if="tupianItem.layer == 4">企业商用</i>
      </template>
<!--      <a :href="INTRO_LINK" target="_blank">
        <div
          v-if="tupianItem.package != 1" class="_pointer label-item  legal-copy-active">
          商用授权<i class="iconfont icon-a-arrowright"/>
        </div>
      </a>-->
      <template v-if="tupianItem.package != 1">
        <a  @click="tag('充值:素材左上角标:图片:click')" :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS" target="_blank"  v-if="tupianItem.layer == 1" class="_pointer legal-copy free label-item  legal-copy-active legal-copy-active">
          所有用户可下载 <i class="iconfont icon-a-arrowright"/>
        </a>
        <a @click="tag('充值:素材左上角标:图片:click')" :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.PERSON" target="_blank"  v-if="tupianItem.layer == 2" class="_pointer legal-copy person label-item  legal-copy-active legal-copy-active">
          成为VIP可下载 <i class="iconfont icon-a-arrowright"/>
        </a>
        <a @click="tag('充值:素材左上角标:图片:click')" :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS" target="_blank"  v-if="tupianItem.layer == 3" class="_pointer legal-copy business label-item  legal-copy-active legal-copy-active">
          商用VIP和企业VIP可下载 <i class="iconfont icon-a-arrowright"/>
        </a>
        <a @click="tag('充值:素材左上角标:图片:click')" :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY" target="_blank"  v-if="tupianItem.layer == 4" class="_pointer legal-copy company label-item  legal-copy-active legal-copy-active">
          仅企业VIP可下载 <i class="iconfont icon-a-arrowright"/>
        </a>
      </template>
    </template>

    <!-- 正版推荐 -->
    <template v-if="tupianItem.type == 2">
      <i class="label-recommend recommend  "/>
    </template>

    <!-- 正版专题 -->
    <template v-if="tupianItem.type == 3">
      <i
        class="label-recommend special "/>
    </template>


  </div>
</template>

<script>
import {fnRouter} from "@/fn";
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import {tag} from "@/utils/statUtil";

export default {
  name: "TupianLabel",
  data(){
    return{
      PAGE_PATH
    }
  },
  props: {
    tupianItem: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    INTRO_LINK() {
      return fnRouter.getRouterLink(PAGE_PATH.INTRODUCE.VIP);
    },
  },
  methods:{
    tag(stat) {
      tag(stat)
    },
  }
}
</script>

<style lang="scss" scoped>
.TupianLabel {
  .icon_badge {
    @include BgImage(71px, 68px, 'pic-package/icon_badge.svg');
    @include Position(1, 5, 0, 0);
    z-index: 8 !important;
  }


  .label-item {
    display: block;
    transition: all 0.5s ease-in-out;
    @include Position(1, 5, 16px, 16px);
    line-height: 28px;
    background: linear-gradient(213deg, #FFF1A4 0%, #FFC04D 100%);
    border-radius: 6px;
    font-size: 14px;
    color: #A45F00;
    padding: 0 8px;
    height: 28px;


    &.legal-copy-active {
      display: none;
      padding-right: 4px;
    }

    &.free {
      background: linear-gradient(145deg, #45A0FF 0%, #00C6FF 100%);
      color: #FFFFFF;
    }

    &.person {
      background: linear-gradient(129deg, #FD9C5D 0%, #FF5967 100%);
      color: #FFFFFF;
    }

    &.business {
      background: linear-gradient(213deg, #FFF1A4 0%, #FFC04D 100%);
      color: rgba(179, 77, 41, 1);
    }

    &.company {
      background: linear-gradient(133deg, #40456B 0%, #292C42 100%);
      color: rgba(250, 228, 178, 1);
    }
  }


  .label-recommend {
    @include Position(1, 5, 16px, 16px);

    &.recommend {
      @include BgImage(88px, 28px, 'home/timeline-pic/icon_PicTagLegalCopyRecommend.svg');
    }

    &.special {
      @include BgImage(88px, 28px, 'home/timeline-pic/icon_PicTagLegalCopySpecial.svg?v=2');
    }
  }
}


</style>
